<template>
  <div class="background-style">
    <div class="background-margin">
      <div class="content2">
        <SwipeBox :images="images" />
        <UserInfoTpl :chetouhao="chetouhao" :cheguahao="cheguahao" :showBindTip="showBindTip" />
        <Panels :bindStatus="bindStatus" :vehicleState="vehicleState" :allBindZero="allBindZero" :cargoType="cargoType" :phWhDriver="phWhDriver" :chetouhao="chetouhao" :cheguahao="cheguahao" :plans="plans" :judgeLoaded="judgeLoaded" />
      </div>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import SwipeBox from './swipeBox';
import UserInfoTpl from './userInfoTpl';
import Panels from './panelTpl';
import Tabbar from '../Public/tabbarTpl';
import api from '@/fetch/api';
import { Toast } from 'vant';
import dayjs from 'dayjs';
import { Dialog } from 'vant';
import store from '@/store';
export default {
  components: {
    SwipeBox,
    UserInfoTpl,
    Panels,
    Tabbar,
  },
  data() {
    return {
      vehicleState: '01',
      chetouhao: '',
      cheguahao: '',
      images: [],
      bindStatus: {},
      showBindTip: false,
      allBindZero: false,
      // 普货/危货分类：通过 judgePhWh 判定，决定首页「我的」「车辆管理」分支
      // 取值：''（未知/新司机）| 'PUHUO'（普货）| 'WEIHUO'（危货）| 'MIXED'（混合）| 'NONE'（新用户，无任何信息）
      cargoType: '',
      // judgePhWh 是否已返回（成功/失败都算返回）： false 时首页提卸货点击要拦住，
      // 避免 cargoType/phWhDriver 还是空串时落入「兜底进 AI 对话」分支
      judgeLoaded: false,
      // judgePhWh 返回的司机类型（权威字段，替代旧的 isNewDriver + cargoType）：
      //   'PUHUO_NEW' / 'PUHUO_OLD' / 'WEIHUO_NEW' / 'WEIHUO_OLD' / 'UNKNOWN' / ''
      // 普货老司机往往没有 yhcl 车辆绑定，isNewDriver 仍是 true，不能再用。
      phWhDriver: '',
      phWhDriverName: '',
      // judgePhWh 返回的计划列表（plans[]），用于"老司机但没计划"判断
      plans: [],
      // 车辆行驶证过期状态（在 init/fetchAndCache 里记录，在 checkCargoType 里根据 phWhDriver 判断是否弹框）
      vehicleExpirationInfo: null,
      // 引导步骤
      steps: [],
    };
  },
  created() {
    // 首页一进来就清理一次旧 session 的 localStorage 缓存，避免司机多次会话后 key 堆积
    this.cleanupOldSessionStorage();
    // 首页一进来就调一次 judgePhWh（按用户要求：传参是 openid，车头号/车挂号为空就传空字符串，
    // 后端会按 openid 单独解析，后续拿到车头车挂会在 getVehicleInfo 里再调一次刷新）
    this.checkCargoType();
    this.getVehicleInfo();
    this.getSwipeList();
    document.title = '苏豪丽天智储预约排队';
    document.body.style.backgroundColor = '#e3e3e3';
    var vehicleState = this.$store.state.vehicleState;
    this.$data.vehicleState = vehicleState;
    // 初始化引导步骤
    if (store.state.isFirstTime) {
      // 判断用户是否是第一次登陆
      // 路由有 bootFlag===third 标签, 如果有说明是车辆管理步骤
      if (this.$route.query.bootFlag === 'third') {
        this.$driverObj.highlight({
          element: '.left_function',
          popover: {
            title: '第三步',
            description: '绑定车辆和车挂',
          },
        });
        return;
      }
      // 路由有 bootFlag===final 标签, 如果有说明是最终步骤
      if (this.$route.query.bootFlag === 'final') {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$driverObj.highlight({
              element: '.panel-item-box',
              popover: {
                title: '🎉恭喜您完成所有备案引导, 请开始预约',
                description: '请选择您的预约服务',
              },
            });
          }, 500);
        });
        return;
      }
      // 正常第一次进入时的引导步骤
      this.steps = [
        {
          popover: {
            title: '🎉欢迎使用<br>苏豪丽天蒸洗预约系统',
            description: '接下来跟随引导完成您的第一份预约订单!',
            showButtons: ['next'],
            nextBtnText: '开始引导',
            onPopoverRender: (popover) => {
              // 设置跳过引导按钮
              const firstButton = document.createElement('button');
              firstButton.innerText = '跳过引导';
              popover.footerButtons.appendChild(firstButton);
              firstButton.addEventListener('click', () => {
                this.$driverObj.destroy();
                store.commit('set_firstTime');
              });
            },
            // 开始引导的逻辑
            onNextClick: () => {
              if (this.$route.query.bootFlag === 'later') {
                this.$driverObj.moveNext();
                return;
              }
              if (this.$data.vehicleState == '03') {
                // 没有绑定手机号
                this.$router.push({
                  name: 'userinfo',
                });
              } else {
                // 已经绑定了手机号的情况/稍后绑定
                this.$driverObj.moveNext();
              }
            },
          },
        },
        {
          element: '.step1',
          popover: {
            title: '进入"我的"页面',
            description: '进入"我的"页面',
            showButtons: [],
          },
        },
      ];
    }
  },
  mounted() {
    // 根据引导标记判断是否需要引导
    if (this.$store.state.isFirstTime && this.$route.query.bootFlag !== 'third') {
      this.$driverObj.setSteps(this.steps);
      if (this.$route.query.bootFlag === 'bindPhone') {
        this.$driverObj.drive(1);
      } else {
        this.$driverObj.drive();
      }
    }
  },
  destroyed() {
    document.body.style.backgroundColor = '#FFFFFF';
    this.destroyDriver();
  },
  methods: {
    // 销毁driver
    destroyDriver() {
      store.state.isFirstTime && this.$driverObj.destroy();
    },
    // 刷新driver
    refreshDriver() {
      store.state.isFirstTime && this.$driverObj.refresh();
    },
    // 清理非当前 session 的 AI 对话缓存 key，避免多次会话后 localStorage 堆积
    cleanupOldSessionStorage() {
      const currentSessionId = localStorage.getItem('ai_session_id') || '';
      const prefixes = ['ai_plan_thk_', 'ai_head_no_', 'ai_trailer_no_'];
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        for (const prefix of prefixes) {
          if (key.startsWith(prefix)) {
            const sessionId = key.slice(prefix.length);
            // 只删与当前 sessionId 不一致的旧 session key
            if (sessionId && sessionId !== currentSessionId) {
              keysToRemove.push(key);
            }
            break;
          }
        }
      }
      keysToRemove.forEach((key) => {
        localStorage.removeItem(key);
        console.log('[cleanupOldSessionStorage] 清理过期 session key:', key);
      });
    },
    async init() {
      const openid = localStorage.getItem('wx_openid');
      // 不再读本地缓存，避免编辑车辆后回首页读到旧数据导致不弹框
      localStorage.removeItem('vehicleInfo');
      return this.fetchAndCache(openid);
    },

    async fetchAndCache(openid) {
      try {
        const [chetouRes, cheguaRes] = await Promise.all([
          api.getChetouList(openid),
          api.getCheguaList(openid),
        ]);
        const chetouInfo = JSON.parse(chetouRes);
        const cheguaInfo = JSON.parse(cheguaRes);

        const today = dayjs();
        console.log('this.cheguahao', this.cheguahao);

        const cheguaList = cheguaInfo.data.filter((item) => item.cheguahao === this.cheguahao);

        const cheguaEndList = cheguaList.map((item) => item.xingshizhengyxq);

        // 记录过期状态，最终是否弹框由 phWhDriver 决定（只有 WEIHUO_OLD 才弹）
        const chetouExpired = today.isAfter(dayjs(chetouInfo.data.xingshizhengyxq), 'day');
        const cheguaExpired = cheguaEndList.some((d) => today.isAfter(dayjs(d), 'day'));
        this.vehicleExpirationInfo = { chetouExpired, cheguaExpired };
        console.log('[init.fetch] today=', today.format('YYYY-MM-DD'), 'chetouEndTime=', chetouInfo.data.xingshizhengyxq, 'cheguaEndList=', cheguaEndList, 'expired=', this.vehicleExpirationInfo);

        console.log('最新车辆信息：', chetouInfo.data, cheguaInfo.data);
      } catch (error) {
        console.error('获取车辆信息失败', error);
        // Toast.fail('车辆信息获取失败，请稍后重试')
      }
    },

    getVehicleInfo() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api
        .getVehicleInfo(openid)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.cheguahao = res.data.cheguahao;
            that.chetouhao = res.data.chetouhao;
            if (that.cheguahao && that.chetouhao) {
              // 先取车辆信息并记录行驶证过期状态，再调 judgePhWh 拿到 phWhDriver，
              // 最后根据 phWhDriver 决定是否弹“车辆信息已过期”提示
              that.init().then(function () {
                that.checkCargoType();
              });
            }
          }
        })
        .catch(function () {
          Toast.fail('连接失败，请刷新页面');
        });
    },
    // 普危分流：首页进来就调 judgePhWh，传参是 openid；
    // 车头号 / 车挂号为空时按用户要求显式传空字符串（不是不传），
    // 后端会按 openid 单独解析（参考 dhyy-api(3).md §3.1）。
    // 失败 / 接口异常 → cargoType 保持 ''（走新司机兜底）。
    checkCargoType() {
      var openid = this.$store.state.wx_info.openid;
      if (!openid) {
        this.phWhDriver = '';
        this.phWhDriverName = '';
        this.plans = [];
        this.judgeLoaded = true;
        this.applyMineTabVisibility();
        return;
      }
      var that = this;
      api.judgePhWh(openid, '', this.chetouhao || '', this.cheguahao || '')
        .then(function (resData) {
          var res;
          try { res = JSON.parse(resData); } catch (e) { res = null; }
          if (res && res.ok && res.data) {
            // 权威字段：phWhDriver / phWhDriverName（替代旧的 isNewDriver + cargoType）
            // cargoType 仍读取保留兼容，但判断全部走 phWhDriver
            that.phWhDriver = res.data.phWhDriver ? String(res.data.phWhDriver) : '';
            that.phWhDriverName = res.data.phWhDriverName ? String(res.data.phWhDriverName) : '';
            that.cargoType = res.data.type ? String(res.data.type) : '';
            that.plans = Array.isArray(res.data.plans) ? res.data.plans : [];
            console.log('[checkCargoType] phWhDriver=', that.phWhDriver, ' name=', that.phWhDriverName, ' type=', that.cargoType, ' plans.length=', that.plans.length);
          } else {
            that.phWhDriver = '';
            that.phWhDriverName = '';
            that.cargoType = '';
            that.plans = [];
          }
          that.applyMineTabVisibility();
          that.checkVehicleExpiration();
          that.judgeLoaded = true;
        })
        .catch(function (err) {
          console.error('[checkCargoType] 失败', err);
          that.phWhDriver = '';
          that.phWhDriverName = '';
          that.cargoType = '';
          that.plans = [];
          that.applyMineTabVisibility();
          that.checkVehicleExpiration();
          that.judgeLoaded = true;
        });
    },
    // 根据 phWhDriver（权威字段）决定「我的」tab 是否显示：
    //   WEIHUO_OLD（危货老司机）         → 显示（需要走车辆管理 / 旧预约）
    //   其他（PUHUO_NEW/OLD、WEIHUO_NEW、UNKNOWN、''）→ 隐藏
    // 不再使用 getBindVehicleState / getJhByChe 兜底
    applyMineTabVisibility() {
      var isWeihuo = this.phWhDriver && this.phWhDriver.indexOf('WEIHUO') === 0;
      var showMine = this.phWhDriver === 'WEIHUO_OLD' ||
                     (isWeihuo && this.$store.state.aiChatVehicleBound);
      this.$store.commit('set_showMineTab', showMine);
    },
    // 根据 phWhDriver 判断是否为危货老司机，只有 WEIHUO_OLD 且行驶证过期时才提示
    checkVehicleExpiration() {
      console.log('[checkVehicleExpiration] phWhDriver=', this.phWhDriver, 'info=', this.vehicleExpirationInfo);
      if (this.phWhDriver !== 'WEIHUO_OLD') return;

      var info = this.vehicleExpirationInfo;
      if (!info) return;

      var chetouExpired = info.chetouExpired;
      var cheguaExpired = info.cheguaExpired;
      if (!chetouExpired && !cheguaExpired) return;

      Dialog.confirm({
        title: '车辆信息已过期',
        message: '车辆信息已过期，请在编辑中上传车辆最新信息',
      }).then(() => {
        this.$router.push({
          name: chetouExpired ? 'chetouList' : 'cheguaList',
        });
      });
    },
    getSwipeList() {
      var that = this;
      api
        .getSwipeList()
        .then(function (res) {
          var resData = JSON.parse(res);
          if (resData.respCode == '0') {
            that.images = [];
            that.images.push(
              { syimgurl: require('@/assets/images/banner_first.jpg') },
              { syimgurl: require('@/assets/images/swiper_1.jpg') }
            );
            if (that.$store.state.isFirstTime && that.$route.query.bootFlag === 'third') {
              that.$nextTick(() => {
                that.$driverObj.highlight({
                  element: '.left_function',
                  popover: {
                    title: '第三步',
                    description: '绑定车辆和车挂',
                  },
                });
              });
            }
          }
        })
        .catch(function () {
          //
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.background-style {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  //background-image: linear-gradient(#316892, #BAD4EC);
  .content2 {
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    //margin: 0;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
